export const LAWYER_TYPE_LAWYER: number = 1;
export const LAWYER_TYPE_ADVOCATE: number = 2;
export const LAWYER_TYPE_LAWYER_COMPANY: number = 3;
export const LAWYER_TYPE_ADVOCATE_COMPANY: number = 4;
